import { WithStyles } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { setELearningPage } from '../actions/eLearning';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ScenarioFactory, {
	IFetchELearningTreeParam,
} from '../scenario/ELearningScenarioFactory';
import { IELearningCommonProps } from './ELearning';

import SiteConfig from '../site.config.json';
import { isMobile } from '../utils/MobileCheck';

const styles = (theme: Theme) =>
	createStyles({
		frame: {
			display: 'inline-flex',
			overflow: 'auto !important',
			width: '100%',
			['-webkit-overflow-scrolling']: 'touch !important',
		},
	});

/**
 * eラーニング概要
 */
class ELearningOutline extends React.Component<IProps> {
	protected elmIframe: React.RefObject<HTMLIFrameElement>;
	protected elmParent: React.RefObject<HTMLDivElement>;
	protected elmForm: React.RefObject<HTMLFormElement>;

	protected resizeFrameWrapper: () => void;

	protected processedPage?: number;

	public constructor(props: IProps) {
		super(props);

		this.elmIframe = React.createRef();
		this.elmParent = React.createRef();
		this.elmForm = React.createRef();
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		if (!this.props.currentTreeItem || this.props.outOfPeriodFlg) {
			return;
		}

		this.loadContent();
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidUpdate(prevProps: IProps) {
		if (
			!this.processedPage ||
			this.processedPage !== this.props.currentPage
		) {
			this.loadContent();
		}
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillUnmount() {
		if (this.resizeFrameWrapper) {
			const type = isMobile() ? 'orientationchange' : 'resize';
			window.removeEventListener(type, this.resizeFrameWrapper);
		}
	}

	public render() {
		const {
			classes,
			careerID,
			currentPage,
			userAttr,
			preview,
		} = this.props;

		if (!this.props.currentTreeItem) {
			return;
		}

		if (this.props.outOfPeriodFlg) {
			return <React.Fragment />;
		}

		return (
			<div className={classes.frame} ref={this.elmParent}>
				<form
					method="POST"
					action={
						SiteConfig.tsqPath + '/tsq/pkg/action/el/outline.action'
					}
					target="eLearning"
					ref={this.elmForm}
				>
					<input type="hidden" name="page" value={currentPage} />
					<input type="hidden" name="careerID" value={careerID} />
					<input type="hidden" name="lang" value={userAttr.lang} />
					<input type="hidden" name="topicID" value={'GA'} />
					<input
						type="hidden"
						name="userId"
						value={userAttr.userId}
					/>
					<input
						type="hidden"
						name="viewMode"
						value={preview ? '1' : '0'}
					/>
					<input
						type="hidden"
						name="accessType"
						value={preview ? '21' : '10'}
					/>
				</form>
				<iframe
					ref={this.elmIframe}
					frameBorder="0"
					title={i18n.t('ELearningOutline_0001')}
					name={i18n.t('ELearningOutline_0002')}
				/>
			</div>
		);
	}

	/**
	 * リサイズハンドラ
	 */
	protected resizeFrame() {
		const innerHeight =
			window.innerHeight || document.documentElement.clientHeight;
		if (!(this.elmParent.current && this.elmIframe.current)) {
			return;
		}
		const rect = this.elmIframe.current.getBoundingClientRect();
		this.elmIframe.current.width = this.elmParent.current.offsetWidth.toString();
		this.elmIframe.current.height = (
			innerHeight -
			(rect.top - window.pageYOffset) -
			8
		).toString();
	}

	/**
	 * 概要ページ読み込み
	 */
	protected loadContent() {
		if (!this.elmIframe.current) {
			return;
		}
		if (!this.elmForm.current) {
			return;
		}
		if (!this.props.currentTreeItem || this.props.outOfPeriodFlg) {
			return;
		}
		this.elmForm.current.submit();
		this.processedPage = this.props.currentPage;
		if (!this.elmIframe.current.onload) {
			this.elmIframe.current.onload = () => {
				this.resizeFrame();
				if (!this.resizeFrameWrapper) {
					this.resizeFrameWrapper = () => {
						this.resizeFrame();
					};
					const type = isMobile() ? 'orientationchange' : 'resize';
					window.addEventListener(type, this.resizeFrameWrapper);
					this.props.fetchELearningTree(this.props.token, {
						careerID: this.props.careerID,
						classID: this.props.classID,
						isPreview: this.props.preview,
						userAttr: this.props.userAttr,
					});
				}
			};
		}
	}
}

const mapStateToProps = (state: IRootState) => ({
	currentPage: state.eLearning.currentPage,
	currentTreeItem: state.eLearning.currentTreeItem,
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchELearningTree: (token: string, arg: IFetchELearningTreeParam) => {
		const s = ScenarioFactory.createFetchELearningTree(dispatch, token);
		s.run(arg);
	},
	setELearningPage: (page: number) => dispatch(setELearningPage({ page })),
});

// tslint:disable-next-line: no-empty-interface
interface IELearningOutlineProps extends IELearningCommonProps {}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IELearningOutlineProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ELearningOutline);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/ELearningOutline.tsx